import request from '@/utils/request'
// 文章详情
export function articleDetail(params) {
  return request({
    url: '/notice/smsInfoDetail/api/n/list',
    method: 'get',
    params
  })
}